module.exports = __webpack_public_path__ + "static/media/Maf_911.ef74efb6.jpg";